/* ---------------------------------------------------------------------------------------------------------------
   MJP - CAMPAGNA PROMOZIONALE
   ---------------------------------------------------------------------------------------------------------------
   Due compiti, entrambi basati su timestamp ASSOLUTI stampati da Liquid (secondi dall'epoch):

   1. Gate autorevole. Liquid stampa il markup con una tolleranza di qualche minuto per lato, perche' l'HTML di
      Shopify puo' essere servito dalla cache e quindi "invecchiare". Qui, che giriamo sempre in tempo reale,
      decidiamo se mostrare o rimuovere. Meglio rimuovere in ritardo di un secondo che promettere una spedizione
      gratuita gia' scaduta.

   2. Countdown. Un solo ticker per pagina aggiorna tutti gli elementi, cosi' popup e badge restano sincronizzati.

   Correzione orologio: l'ora reale non puo' essere precedente al momento in cui il server ha reso la pagina, quindi
   alziamo Date.now() al valore del server se il browser e' indietro. Contro un orologio spostato molto avanti non
   esiste difesa lato client, e non ha senso inventarne una.
   --------------------------------------------------------------------------------------------------------------- */

(function () {
  'use strict';

  var SELECTOR = '[data-mjp-fs]';
  var FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

  var serverSkewMs = 0;
  var ticker = null;
  var escapeBound = false;

  function isDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function toMs(value) {
    var n = parseInt(value, 10);
    return isNaN(n) ? 0 : n * 1000;
  }

  function now() {
    return Date.now() + serverSkewMs;
  }

  /* Registra lo scarto fra orologio del server e del browser, tenendo solo la correzione in avanti. */
  function calibrate(el) {
    var serverNow = toMs(el.getAttribute('data-server-now'));
    if (!serverNow) return;
    var skew = serverNow - Date.now();
    if (skew > serverSkewMs) serverSkewMs = skew;
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  /* Scrive solo se il valore e' cambiato. Non e' un vezzo: ogni scrittura di textContent sostituisce un nodo di
     testo, cioe' e' una mutazione del DOM, e piu' in basso c'e' un MutationObserver che reagisce alle mutazioni.
     Scrivere a ogni tick creerebbe un anello di retroazione observer -> init -> tick -> observer. */
  function setText(el, value) {
    if (el && el.textContent !== value) el.textContent = value;
  }

  /* ---------------------------------------------------------------------------------------------------------------
     Gate
     --------------------------------------------------------------------------------------------------------------- */

  function isLive(el) {
    if (isDesignMode() && el.getAttribute('data-preview') === '1') return true;

    var start = toMs(el.getAttribute('data-start'));
    var end = toMs(el.getAttribute('data-end'));
    if (!start || !end || end <= start) return false;

    var t = now();
    return t >= start && t < end;
  }

  /* Il popup gestisce la propria apertura (ritardo, frequenza): qui ci limitiamo a rimuoverlo se e' scaduto. */
  function applyGate(el) {
    if (isLive(el)) {
      if (!el.hasAttribute('data-mjp-fs-popup') && el.hidden) el.hidden = false;
      return true;
    }

    /* Nell'editor non si rimuove mai nulla: il merchant deve poter selezionare e impaginare anche fuori finestra. */
    if (isDesignMode()) return false;

    /* Fuori finestra l'elemento sparisce del tutto: niente markup morto, niente popup fantasma. */
    if (el.parentNode) el.parentNode.removeChild(el);
    return false;
  }

  /* ---------------------------------------------------------------------------------------------------------------
     Countdown
     --------------------------------------------------------------------------------------------------------------- */

  function renderCountdown(el, remainingMs) {
    var totalSeconds = Math.max(0, Math.floor(remainingMs / 1000));
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    var compact = el.querySelector('[data-mjp-fs-cd-compact]');
    if (compact) {
      /* Formato breve per il badge: "2g 04:31:07", oppure "04:31:07" nell'ultimo giorno. */
      setText(
        compact,
        (days > 0 ? days + (compact.getAttribute('data-unit-day') || 'g') + ' ' : '') +
          pad(hours) + ':' + pad(minutes) + ':' + pad(seconds)
      );
    }

    /* Formato del badge: solo le ore ("71h"). Sotto l'ora si passa ai minuti, altrimenti nell'ultima ora
       il cliente leggerebbe "GRATIS PER 0h", che è il contrario di quello che vogliamo dirgli. */
    var hoursOnly = el.querySelector('[data-mjp-fs-cd-hours]');
    if (hoursOnly) {
      var totalHours = Math.floor(totalSeconds / 3600);
      var totalMinutes = Math.floor(totalSeconds / 60);
      setText(hoursOnly, totalHours >= 1 ? totalHours + 'h' : Math.max(1, totalMinutes) + 'm');
    }

    var slots = el.querySelectorAll('[data-mjp-fs-cd-value]');
    for (var i = 0; i < slots.length; i++) {
      var unit = slots[i].getAttribute('data-mjp-fs-cd-value');
      var value = unit === 'days' ? days : unit === 'hours' ? hours : unit === 'minutes' ? minutes : seconds;
      setText(slots[i], unit === 'days' ? String(days) : pad(value));
    }

    /* Il blocco giorni sparisce quando non serve piu': evita un "0 GIORNI" che invecchia male. */
    var dayUnit = el.querySelector('[data-mjp-fs-cd-unit="days"]');
    if (dayUnit && dayUnit.hidden !== (days === 0)) dayUnit.hidden = days === 0;
  }

  function tick() {
    var elements = document.querySelectorAll(SELECTOR);

    if (!elements.length) {
      if (ticker) {
        clearInterval(ticker);
        ticker = null;
      }
      return;
    }

    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      if (!applyGate(el)) continue;

      var countdown = el.querySelector('[data-mjp-fs-countdown]');
      if (!countdown) continue;

      var end = toMs(el.getAttribute('data-end'));
      var remaining = end - now();

      if (remaining <= 0 || !end) {
        if (!countdown.hidden) countdown.hidden = true;
        continue;
      }

      if (countdown.hidden) countdown.hidden = false;
      renderCountdown(countdown, remaining);
    }
  }

  function startTicker() {
    if (ticker) return;
    ticker = setInterval(tick, 1000);
  }

  /* ---------------------------------------------------------------------------------------------------------------
     Popup
     --------------------------------------------------------------------------------------------------------------- */

  function frequencyKey(popup) {
    return popup.getAttribute('data-storage-key') || 'mjp_fs_popup';
  }

  function alreadySeen(popup) {
    if (isDesignMode()) return false;

    var mode = popup.getAttribute('data-frequency') || 'session';
    if (mode === 'always') return false;

    try {
      if (mode === 'session') return sessionStorage.getItem(frequencyKey(popup)) === '1';

      /* "Una volta al giorno": salviamo la data locale del visitatore, sufficiente per non risultare invadenti. */
      return localStorage.getItem(frequencyKey(popup)) === new Date().toDateString();
    } catch (e) {
      /* Storage negato (navigazione privata, blocco cookie): meglio mostrarlo una volta in piu' che mai. */
      return false;
    }
  }

  function markSeen(popup) {
    if (isDesignMode()) return;

    var mode = popup.getAttribute('data-frequency') || 'session';
    if (mode === 'always') return;

    try {
      if (mode === 'session') sessionStorage.setItem(frequencyKey(popup), '1');
      else localStorage.setItem(frequencyKey(popup), new Date().toDateString());
    } catch (e) {
      /* Niente storage disponibile: il popup riapparira' al prossimo caricamento. Accettabile. */
    }
  }

  function openPopup(popup) {
    if (popup.classList.contains('is-open')) return;

    popup.__mjpReturnFocus = document.activeElement;
    popup.hidden = false;

    /* Due frame, non uno: il primo serve al browser per prendere atto che l'elemento non e' piu' display:none,
       il secondo per far partire davvero la transizione. Con un frame solo il popup comparirebbe di scatto. */
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        popup.classList.add('is-open');
        var closeButton = popup.querySelector('[data-mjp-fs-pop-close]');
        if (closeButton) closeButton.focus({ preventScroll: true });
      });
    });
  }

  function closePopup(popup) {
    if (!popup.classList.contains('is-open')) return;

    popup.classList.remove('is-open');
    markSeen(popup);

    var returnFocus = popup.__mjpReturnFocus;
    if (returnFocus && typeof returnFocus.focus === 'function' && document.body.contains(returnFocus)) {
      returnFocus.focus({ preventScroll: true });
    }

    window.setTimeout(function () {
      if (popup.classList.contains('is-open')) return;
      popup.hidden = true;
    }, 500);
  }

  function openPopups() {
    return document.querySelectorAll('.mjp-fs-pop.is-open');
  }

  /* Un solo ascoltatore su document per tutta la pagina, invece di uno per popup: nell'editor del tema le sezioni
     vengono ricaricate di continuo e ogni ricarica lascerebbe dietro di se' un ascoltatore orfano. */
  function bindGlobalKeys() {
    if (escapeBound) return;
    escapeBound = true;

    document.addEventListener('keydown', function (event) {
      var popups = openPopups();
      if (!popups.length) return;

      var popup = popups[popups.length - 1];

      if (event.key === 'Escape') {
        closePopup(popup);
        return;
      }

      if (event.key !== 'Tab') return;

      /* Il popup si dichiara modale (aria-modal): il tasto Tab deve restare dentro, altrimenti chi naviga da
         tastiera finisce sulla pagina sottostante senza accorgersene e senza poter tornare indietro. */
      var focusables = [];
      var candidates = popup.querySelectorAll(FOCUSABLE);

      for (var i = 0; i < candidates.length; i++) {
        if (candidates[i].offsetParent !== null || candidates[i] === document.activeElement) {
          focusables.push(candidates[i]);
        }
      }

      if (!focusables.length) return;

      var first = focusables[0];
      var last = focusables[focusables.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      } else if (!popup.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function setupPopup(popup) {
    if (popup.getAttribute('data-mjp-fs-ready') === '1') return;
    popup.setAttribute('data-mjp-fs-ready', '1');

    calibrate(popup);
    if (!applyGate(popup) && !isDesignMode()) return;

    popup.hidden = true;
    bindGlobalKeys();

    var closers = popup.querySelectorAll('[data-mjp-fs-pop-close]');
    for (var i = 0; i < closers.length; i++) {
      closers[i].addEventListener('click', function () {
        closePopup(popup);
      });
    }

    popup.addEventListener('click', function (event) {
      if (event.target === popup) closePopup(popup);
    });

    /* Chi clicca una CTA ha gia' avuto il messaggio: non glielo riproponiamo. */
    var links = popup.querySelectorAll('a[href]');
    for (var j = 0; j < links.length; j++) {
      links[j].addEventListener('click', function () {
        markSeen(popup);
      });
    }

    /* Nell'editor il popup si apre solo con "Anteprima nell'editor" accesa. Senza, resta in pagina ma chiuso:
       altrimenti coprirebbe qualsiasi cosa il merchant stia modificando. */
    if (isDesignMode() && popup.getAttribute('data-preview') !== '1') return;

    if (alreadySeen(popup)) {
      if (popup.parentNode) popup.parentNode.removeChild(popup);
      return;
    }

    var delay = parseInt(popup.getAttribute('data-delay'), 10);
    if (isNaN(delay) || delay < 0) delay = 0;

    window.setTimeout(function () {
      if (!document.body.contains(popup)) return;

      if (!isLive(popup)) {
        if (popup.parentNode) popup.parentNode.removeChild(popup);
        return;
      }

      openPopup(popup);
    }, delay * 1000);
  }

  /* ---------------------------------------------------------------------------------------------------------------
     Avvio
     --------------------------------------------------------------------------------------------------------------- */

  function init(root) {
    var elements = (root || document).querySelectorAll(SELECTOR);
    if (!elements.length) return;

    for (var i = 0; i < elements.length; i++) calibrate(elements[i]);

    for (var j = 0; j < elements.length; j++) {
      if (elements[j].hasAttribute('data-mjp-fs-popup')) setupPopup(elements[j]);
      else applyGate(elements[j]);
    }

    tick();
    startTicker();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  /* Il badge vive dentro product-info, che Impact sostituisce interamente al cambio variante, e altre app possono
     iniettare markup a caricamento avvenuto. Un observer con debounce copre entrambi i casi senza dipendere dai nomi
     degli eventi interni del tema. Le mutazioni prodotte da noi stessi vengono ignorate. */
  if (typeof MutationObserver === 'function') {
    var rescanTimer = null;

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var target = mutations[i].target;

        if (!mutations[i].addedNodes.length) continue;
        if (target && target.nodeType === 1 && target.closest && target.closest(SELECTOR)) continue;

        clearTimeout(rescanTimer);
        rescanTimer = setTimeout(function () {
          init();
        }, 100);
        return;
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* Editor del tema: quando una sezione viene ricaricata, i badge al suo interno vanno riagganciati. */
  if (isDesignMode()) {
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  }
})();
